import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { toggleCollapsedNav } from "store/slices/themeSlice";
import constantsService from "services/constants";
import { updateConstants } from "store/slices/authSlice";
import SideNav from "components/layout-components/SideNav";
import TopNav from "components/layout-components/TopNav";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import PageHeader from "components/layout-components/PageHeader";
import Footer from "components/layout-components/Footer";
import { Layout, Grid } from "antd";
import { useLocation } from "react-router-dom";

import navigationConfig from "configs/NavigationConfig";
import {
  SIDE_NAV_WIDTH,
  SIDE_NAV_COLLAPSED_WIDTH,
  NAV_TYPE_SIDE,
  NAV_TYPE_TOP,
  DIR_RTL,
  DIR_LTR,
} from "constants/ThemeConstant";
import utils from "utils";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({ navCollapsed, navType, direction, children }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const fetchConstants = async () => {
      const response = await constantsService.getConstants();
      if (response) {
        dispatch(updateConstants(response));
      }
    };
    fetchConstants();
  }, [dispatch]);
  const isArticleDetail =
    window?.location?.pathname.includes("/article-detail");
  const currentRouteInfo = utils.getRouteInfo(
    navigationConfig,
    location.pathname
  );
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = screens.length === 0 ? false : !screens.includes("lg");
  const isNavSide = navType === NAV_TYPE_SIDE;
  const isNavTop = navType === NAV_TYPE_TOP;

  useEffect(() => {
    if (isNavSide && !isMobile) {
      dispatch(toggleCollapsedNav(true));
    }
  }, [dispatch, isNavSide, isMobile]);

  const getLayoutGutter = () => {
    if (isNavTop || isMobile) {
      return 0;
    }
    if (isArticleDetail) {
      return 0;
    }
    return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH;
  };

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter() };
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter() };
    }
    return { paddingLeft: getLayoutGutter() };
  };

  return (
    <Layout>
      {!isArticleDetail && <HeaderNav isMobile={isMobile} />}
      {isNavTop && !isMobile ? <TopNav routeInfo={currentRouteInfo} /> : null}
      <Layout className="app-container">
        {isNavSide && !isMobile && !isArticleDetail ? (
          <SideNav routeInfo={currentRouteInfo} isMobile={isMobile} />
        ) : null}
        <Layout className="app-layout" style={getLayoutDirectionGutter()}>
          <div
            className={`app-content ${isNavTop ? "layout-top-nav" : ""}`}
            style={{
              marginTop: isArticleDetail ? "0px" : undefined,
              paddingTop: isArticleDetail ? "0px" : undefined,
            }}
          >
            <PageHeader
              display={currentRouteInfo?.breadcrumb}
              title={currentRouteInfo?.title}
            />
            <Content className="h-100">{children}</Content>
          </div>
          <Footer />
        </Layout>
      </Layout>
      {isMobile && <MobileNav />}
    </Layout>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;
  return { navCollapsed, navType, locale };
};

export default connect(mapStateToProps)(React.memo(AppLayout));
